import React, { useEffect } from "react"
import { Row, Col, Card, CardBody, Button } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { fetchBazaarList } from "../../redux/actions/pvs"

const BazaarList = ({ enquiryFormPath = "/volunteer/bazaar-enquiry" }) => {
  document.title = "Bazaars | PULA"

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const token = useSelector(state => state.auth.token)
  const bazaarList = useSelector(state => state.pvs.bazaarList) || []

  useEffect(() => {
    dispatch(fetchBazaarList({ offset: 1 }, token))
  }, [])

  const activeBazaars = bazaarList.filter(
    bazaar => Number(bazaar.is_active) === 1
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        <h4 className="h4 mb-3 nom-title">Bazaars</h4>

        {activeBazaars.length === 0 && (
          <Card>
            <CardBody>
              <p className="mb-0 text-muted">No active bazaars right now.</p>
            </CardBody>
          </Card>
        )}

        <Row>
          {activeBazaars.map(bazaar => (
            <Col md={6} lg={4} key={bazaar.enc_bazaar_id} className="mb-3">
              <Card className="h-100">
                <CardBody className="d-flex flex-column">
                  <h5 className="mb-2">{bazaar.bazaar_name}</h5>
                  <p className="text-muted mb-1">
                    {bazaar.formatted_start_date} - {bazaar.formatted_end_date}
                  </p>
                  <p className="text-muted mb-3">{bazaar.location}</p>
                  <Button
                    color="primary"
                    className="mt-auto"
                    onClick={() =>
                      navigate(
                        `${enquiryFormPath}?id=${bazaar.enc_bazaar_id}`
                      )
                    }
                  >
                    Add Walk-In
                  </Button>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  )
}

export default BazaarList
